import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  TextField,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Button,
  Typography,
  FormControlLabel,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  MenuItem,
} from "@mui/material";

import { useMediaQuery, useTheme } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import axios from "axios";
import dayjs from "dayjs";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate, useLocation } from "react-router-dom";
import {
  updatepos,
  getAllItems,
  getCategories,
  fetchSubCategories,
  fetchItemsByCategoryAndSubcategory,
  GetApprovedSuppliers as fetchSuppliers,
  getUnits,
  ApproveSolistapi,
  CreatePurchaseVoucher,
  UpdatePurchaseVoucher,
  fetchpos,
  GetNextPvNo,
  getSizes,
} from "../../../Services/Services";
import Autocomplete from "@mui/material/Autocomplete";
import { toast, ToastContainer } from "react-toastify";

import AddItemForm from "../Inventory/ItemForm";
import { useCallback } from "react";
import { debounce } from "lodash";

export default function Purchaseentryform() {

    const getSelectedDivision = () => {
    try {
      const stored = localStorage.getItem("selectedDivision");
      return stored ? JSON.parse(stored) : null;
    } catch (e) {
      console.error("Failed to parse selectedDivision:", e);
      return null;
    }
  };
  const division = getSelectedDivision();

  const [formData, setFormData] = useState({
    voucher_no: "",
    invoice_no: "",
    invoice_date: "",
    lr_no: "",
    grn_no: "",
    purchase_order: "",
    vehicle_no: "",
    payment_status: "",
    supplier: "",
    division: division?.division_id || "",
    project: "",
    billing_name: "",
    billing_address: "",
    billing_pan: "",
    billing_gst: "",
    billing_division: division?.division_id || "",
    billing_email: "",
    billing_contact: "",
    billed_to_name: "CRANOIST MATERIAL HANDLING EQUIPMENTS PVT. LTD.",
    billed_to_email: "info@cranoistmhe.com",
    billed_to_contact: "9825586999",
    billed_to_state_name: "Chattisgarh",
    billed_to_state_code: "22",
    billed_to_gst_no: "22AAECC0064F1ZC",
    billed_to_pan_no: "AAECC0064F",
    billed_to_address:
      "Shed No.6, Industrial Growth Centre, Borai, Rasamada, Chhattisgarh 491001",
    shipping_address: "",
    shipping_contact: "",
    shipping_phone: "",
    narration: "",               // ✅ new
    total_amount: "0.00",        // ✅ new
    gst_amount: "0.00",          // ✅ new
    other_expense: "0.00",       // ✅ new
    final_amount: "0.00",        // ✅ new
    items: [
      {
        category: null,
        sub_category: null,
        item: null,
        description: "",
        quantity: 0,
        used_qty: 0,
        unit: "",
        unit_name: "",
        rate: "",
        amount: "",
        size: null,
        gst_percentage: "",       // ✅ new per item
        gst_amount: "0.00",       // ✅ new per item
      },
    ],
    created_by: localStorage.getItem("user_id"),
  });

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const [itemOptions, setItemOptions] = useState({});
  const [openItemModal, setOpenItemModal] = useState(false);
  const [subcategories, setSubcategories] = useState([]);
  const [categories, setCategories] = useState([]);
  const [includeShipping, setIncludeShipping] = useState(false);
  const [rowErrors, setRowErrors] = useState([]);
  const [unitOptions, setUnitOptions] = useState([]);
  const [sizeOptions, setSizeOptions] = useState([]);
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [terms, setTerms] = useState([
    { key: "Delivery Period", value: "Ready stock", is_default: true },
    { key: "Warranty", value: "12 months from delivery", is_default: true },
    { key: "Freight", value: "Ex works. Raipur", is_default: true },
    { key: "Inspection", value: "By buyer at site", is_default: true },
    { key: "Quality", value: "As per specifications", is_default: true },
    {
      key: "Rejection/Claim",
      value: "Allowed within 7 days",
      is_default: true,
    },
    { key: "Jurisdiction", value: "Durg", is_default: true },
    {
      key: "Payment Terms",
      value: "Material received after 30 days",
      is_default: true,
    },
    { key: "GST", value: "18% applicable", is_default: true },
    { key: "Billing gst no-", value: division?.gst_no, is_default: true },
  ]);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitErrors, setSubmitErrors] = useState({});
  const [itemFieldErrors, setItemFieldErrors] = useState([]);

  // Purchase Order states
  const [purchases, setPurchases] = useState([]);
  const [selectedPO, setSelectedPO] = useState(null);
  const [purchaseLoading, setPurchaseLoading] = useState(false);
  const [purchaseSearch, setPurchaseSearch] = useState("");
  const [formErrors, setFormErrors] = useState({});

  const location = useLocation();
  const locationState = location.state || {};
  const issueData = locationState.issue || null;
  const poDataFromState = locationState.poData || null;
  const poData = poDataFromState || issueData;
  const isEdit = locationState.isEdit || !!issueData;

  // ===================== HELPER FUNCTIONS FOR CALCULATIONS =====================
  const calculateItemGST = (amount, gstPercent) => {
    return ((parseFloat(amount) || 0) * (parseFloat(gstPercent) || 0) / 100).toFixed(2);
  };

  const recalcMainTotals = (items, otherExpense) => {
    let totalAmount = 0;
    let totalGST = 0;
    items.forEach(item => {
      totalAmount += parseFloat(item.amount) || 0;
      totalGST += parseFloat(item.gst_amount) || 0;
    });
    const finalAmount = totalAmount + totalGST + (parseFloat(otherExpense) || 0);
    return {
      total_amount: totalAmount.toFixed(2),
      gst_amount: totalGST.toFixed(2),
      final_amount: finalAmount.toFixed(2),
    };
  };

  const updateTotals = (updatedItems, otherExpense = formData.other_expense) => {
    const totals = recalcMainTotals(updatedItems, otherExpense);
    setFormData(prev => ({
      ...prev,
      total_amount: totals.total_amount,
      gst_amount: totals.gst_amount,
      final_amount: totals.final_amount,
      items: updatedItems,
    }));
  };

  const addItemRow = () => {
    const newItem = {
      category: null,
      sub_category: null,
      item: null,
      description: "",
      quantity: 0,
      used_qty: 0,
      unit: "",
      unit_name: "",
      rate: "",
      amount: "",
      size: null,
      gst_percentage: "",
      gst_amount: "0.00",
    };
    const updatedItems = [...formData.items, newItem];
    updateTotals(updatedItems, formData.other_expense);
  };

  const handleItemChange = (index, field, value) => {
    const updatedItems = [...formData.items];
    const row = { ...updatedItems[index] };

    // Update the field
    row[field] = value;

    // Recalculate amount if quantity or rate changes
    if (field === "quantity" || field === "rate") {
      const qty = parseFloat(field === "quantity" ? value : row.quantity) || 0;
      const rate = parseFloat(field === "rate" ? value : row.rate) || 0;
      row.amount = (qty * rate).toFixed(2);
    }

    // Recalculate GST and item total if amount or gst_percentage changes
    if (field === "amount" || field === "gst_percentage") {
      row.gst_amount = calculateItemGST(row.amount, row.gst_percentage);
    }

    updatedItems[index] = row;
    updateTotals(updatedItems, formData.other_expense);

    // Clear row error for this field if any
    if (itemFieldErrors[index] && itemFieldErrors[index][field]) {
      const newItemErrors = [...itemFieldErrors];
      delete newItemErrors[index][field];
      if (Object.keys(newItemErrors[index]).length === 0) delete newItemErrors[index];
      setItemFieldErrors(newItemErrors);
    }
  };

  const deleteItemRow = (index) => {
    const updatedItems = formData.items.filter((_, i) => i !== index);
    updateTotals(updatedItems, formData.other_expense);
    if (itemFieldErrors[index]) {
      const newItemErrors = [...itemFieldErrors];
      delete newItemErrors[index];
      setItemFieldErrors(newItemErrors);
    }
  };

  const handleOtherExpenseChange = (value) => {
    const otherExp = value || "0.00";
    const totals = recalcMainTotals(formData.items, otherExp);
    setFormData(prev => ({
      ...prev,
      other_expense: otherExp,
      total_amount: totals.total_amount,
      gst_amount: totals.gst_amount,
      final_amount: totals.final_amount,
    }));
  };

  // ===================== EXISTING CODE (mostly unchanged) =====================
  const defaultLabels = [
    "Delivery Period",
    "Warranty",
    "Freight",
    "Inspection",
    "Quality",
    "Rejection/Claim",
    "Jurisdiction",
    "Payment Terms",
    "TCS/TDS",
    "Remark",
  ];

  const [suppliers, setSuppliers] = useState([]);
  const [supplierLoading, setSupplierLoading] = useState(false);
  const [supplierSearch, setSupplierSearch] = useState("");
  const [project, setProject] = useState([]);
  const [projectLoading, setProjectLoading] = useState(false);
  const [projectSearch, setProjectSearch] = useState("");

  const fetchSupplier = async (page = 1, filters = {}) => {
    try {
      setSupplierLoading(true);
      const response = await fetchSuppliers(page, filters);
      const results = Array.isArray(response.results) ? response.results : response || [];
      if (page === 1) setSuppliers(results);
      else setSuppliers((prev) => [...prev, ...results]);
    } catch (err) {
      toast.error("Failed to load supplier list");
    } finally {
      setSupplierLoading(false);
    }
  };

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      fetchSupplier(1, { name: supplierSearch });
    }, 500);
    return () => clearTimeout(delayDebounce);
  }, [supplierSearch]);

  useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        const catRes = await getCategories();
        const unitRes = await getUnits();
        const sizeRes = await getSizes();
        setCategories(Array.isArray(catRes) ? catRes : catRes?.results || []);
        setUnitOptions(unitRes);
        setSizeOptions(sizeRes);
      } catch (error) { }
    };

    if (isEdit && poData) {
      setFormData({
        ...formData,
        ...poData,
        voucher_no: poData.voucher_no || poData.purchase_number || "",
        purchase_order: poData.purchase_order || "",
        vehicle_no: poData.vehicle_no || "",
        created_by: localStorage.getItem("user_id"),
        billing_email: poData.billing_email || "",
        billing_contact: poData.billing_contact || "",
        billed_to_name: poData.billed_to_name || "CRANOIST MHE PVT. LTD.",
        billed_to_email: poData.billed_to_email || "info@cranoistmhe.com",
        billed_to_contact: poData.billed_to_contact || "9302122967",
        billed_to_state_name: poData.billed_to_state_name || "Chattisgarh",
        billed_to_state_code: poData.billed_to_state_code || "22",
        billed_to_gst_no: poData.billed_to_gst_no || division?.gst_no,
        billed_to_pan_no: poData.billed_to_pan_no || division?.pan_no,
        billed_to_address: poData.billed_to_address || division?.address,
        narration: poData.narration || "",
        other_expense: poData.other_expense || "0.00",
        items: (poData.items || []).map((it) => ({
          ...it,
          category: it.category ? { id: it.category, name: it.category_name || "" } : null,
          sub_category: it.sub_category ? { subcat_id: it.sub_category, name: it.sub_category_name || "" } : null,
          item: it.item ? { id: it.item, name: it.item_name || "" } : null,
          unit: it.unit ?? it.uom ?? "",
          unit_name: it.unit_name ?? it.uom_name ?? "",
          description: it.description ?? it.item_name ?? "",
          rate: parseFloat(it.rate) || 0,
          quantity: parseFloat(it.quantity) || 0,
          amount: (parseFloat(it.rate) || 0) * (parseFloat(it.quantity) || 0),
          gst_percentage: it.gst_percentage || "",
          gst_amount: it.gst_amount || "0.00",
        })),
      });
      const totals = recalcMainTotals(poData.items || [], poData.other_expense || "0.00");
      setFormData(prev => ({ ...prev, ...totals }));
      setIncludeShipping(!!poData.shipping_address);
      setTerms(poData.terms_conditions || []);
    }

    const fetchItems = async () => {
      const data = await getAllItems();
      if (Array.isArray(data)) setItemOptions(data);
    };
    fetchItems();
    fetchDropdowns();

    if (!isEdit) {
      fetchNextVoucherNo();
    }
  }, []);

  const fetchNextVoucherNo = async () => {
    try {
      const data = await GetNextPvNo();
      if (data && data.purchase_voucher_no) {
        setFormData((prev) => ({ ...prev, voucher_no: data.purchase_voucher_no }));
      }
    } catch (error) {
      console.error("Error fetching voucher no:", error);
    }
  };

  const handleChange = (field) => (e) => {
    setFormData({ ...formData, [field]: e.target.value });
    if (submitErrors[field]) {
      setSubmitErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  const handleFieldChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    if (formErrors[field]) {
      setFormErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  const handlePOChange = async (e, newValue) => {
    setSelectedPO(newValue);
    if (newValue) {
      try {
        const mappedItems = (newValue.items || []).map((item) => ({
          category: item.category ? { id: item.category, name: item.category_name || "" } : null,
          sub_category: item.sub_category ? { subcat_id: item.sub_category, name: item.sub_category_name || "" } : null,
          item: item.item ? { id: item.item, name: item.item_name || "" } : null,
          unit: item.unit || "",
          unit_name: item.unit_name || "",
          description: item.description || item.item_name || "",
          quantity: parseFloat(item.quantity) || 0,
          used_qty: 0,
          rate: parseFloat(item.rate) || 0,
          amount: (parseFloat(item.rate) || 0) * (parseFloat(item.quantity) || 0),
          size: item.size ? (typeof item.size === "object" ? item.size : { id: item.size, name: item.size_name || "" }) : null,
          size_name: item.size_name || "",
          gst_percentage: item.gst_percentage || "",
          gst_amount: "0.00",
        }));
        const newForm = {
          ...formData,
          purchase_order: newValue.id,
          supplier: formData.supplier || newValue.supplier || "",
          billing_name: formData.billing_name || newValue.billing_name || "",
          billing_address: formData.billing_address || newValue.billing_address || "",
          billing_pan: formData.billing_pan || newValue.billing_pan || "",
          billing_gst: formData.billing_gst || newValue.billing_gst || "",
          billing_email: formData.billing_email || newValue.billing_email || "",
          billing_contact: formData.billing_contact || newValue.billing_contact || "",
          project: formData.project || newValue.project || "",
          items: mappedItems.length > 0 ? mappedItems : formData.items,
        };
        setFormData(newForm);
        const totals = recalcMainTotals(mappedItems, formData.other_expense);
        setFormData(prev => ({ ...prev, ...totals }));
        if (newValue.terms_conditions?.length > 0) setTerms(newValue.terms_conditions);
        toast.success(`PO ${newValue.po_number} data loaded!`);
        if (formErrors.purchase) setFormErrors((prev) => ({ ...prev, purchase: "" }));
      } catch (error) {
        toast.error("Failed to load PO data");
      }
    } else {
      setFormData((prev) => ({ ...prev, purchase_order: "" }));
    }
  };

  const handleTermChange = (index, field, value) => {
    const updatedTerms = [...terms];
    updatedTerms[index][field] = value;
    setTerms(updatedTerms);
  };

  const [errors, setErrors] = useState({
    billing_pan: "",
    billing_gst: "",
    billed_to_email: "",
    billed_to_contact: "",
    billed_to_pan_no: "",
    billed_to_gst_no: "",
    billing_email: "",
    billing_contact: "",
  });

  const validateField = (field, value) => {
    let error = "";
    if (field === "billing_pan") {
      const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
      if (value && !panRegex.test(value.toUpperCase())) error = "Invalid PAN format";
    }
    if (field === "billing_email" || field === "billed_to_email") {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (value && !emailRegex.test(value)) error = "Invalid email format";
    }
    if (field === "billing_contact" || field === "billed_to_contact" || field === "shipping_phone") {
      const cleanValue = value.replace(/[\s-]/g, "");
      const phoneRegex = /^[6-9]\d{9}$/;
      const internationalRegex = /^\+\d{10,14}$/;
      if (value && cleanValue.length > 0) {
        if (!phoneRegex.test(cleanValue) && !internationalRegex.test(cleanValue)) {
          error = "Invalid phone number";
        }
      }
    }
    if (field === "billing_gst") {
      const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
      if (value && !gstRegex.test(value.toUpperCase())) error = "Invalid GSTIN format";
    }
    setErrors((prev) => ({ ...prev, [field]: error }));
    return error;
  };

  const validateForm = () => {
    const newErrors = {};
    const newItemErrors = [];

    if (!formData.voucher_no) newErrors.voucher_no = "Voucher No is required";
    if (!formData.supplier) newErrors.supplier = "Supplier is required";

    if (formData.billed_to_email) {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(formData.billed_to_email)) newErrors.billed_to_email = "Invalid email format";
    }
    if (formData.billing_email) {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(formData.billing_email)) newErrors.billing_email = "Invalid email format";
    }
    if (formData.billing_contact) {
      const cleanPhone = formData.billing_contact.replace(/[\s-]/g, "");
      const phoneRegex = /^[6-9]\d{9}$/;
      const internationalRegex = /^\+\d{10,14}$/;
      if (!phoneRegex.test(cleanPhone) && !internationalRegex.test(cleanPhone)) newErrors.billing_contact = "Invalid phone number format";
    }
    if (formData.billed_to_contact) {
      const cleanPhone = formData.billed_to_contact.replace(/[\s-]/g, "");
      const phoneRegex = /^[6-9]\d{9}$/;
      const internationalRegex = /^\+\d{10,14}$/;
      if (!phoneRegex.test(cleanPhone) && !internationalRegex.test(cleanPhone)) newErrors.billed_to_contact = "Invalid phone number format";
    }

    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
    if (formData.billing_pan && !panRegex.test(formData.billing_pan.toUpperCase())) newErrors.billing_pan = "Invalid PAN format";
    const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    if (formData.billing_gst && !gstRegex.test(formData.billing_gst.toUpperCase())) newErrors.billing_gst = "Invalid GSTIN format";
    if (formData.billed_to_pan_no && !panRegex.test(formData.billed_to_pan_no.toUpperCase())) newErrors.billed_to_pan_no = "Invalid PAN format";
    if (formData.billed_to_gst_no && !gstRegex.test(formData.billed_to_gst_no.toUpperCase())) newErrors.billed_to_gst_no = "Invalid GSTIN format";

    if (includeShipping && formData.shipping_phone) {
      const cleanPhone = formData.shipping_phone.replace(/[\s-]/g, "");
      const phoneRegex = /^[6-9]\d{9}$/;
      const internationalRegex = /^\+\d{10,14}$/;
      if (!phoneRegex.test(cleanPhone) && !internationalRegex.test(cleanPhone)) newErrors.shipping_phone = "Invalid phone number format";
    }

    if (formData.items.length === 0) {
      newErrors.items = "At least one item is required";
    } else {
      formData.items.forEach((item, index) => {
        const itemError = {};
        let hasError = false;
        if (!item.category) { itemError.category = "Category is required"; hasError = true; }
        if (!item.item) { itemError.item = "Item is required"; hasError = true; }
        if (!item.quantity || parseFloat(item.quantity) <= 0) { itemError.quantity = "Valid quantity is required"; hasError = true; }
        if (!item.unit) { itemError.unit = "Unit is required"; hasError = true; }
        if (!item.rate || parseFloat(item.rate) < 0) { itemError.rate = "Valid rate is required"; hasError = true; }
        if (hasError) newItemErrors[index] = itemError;
      });
    }
    return { fieldErrors: newErrors, itemErrors: newItemErrors };
  };

  const handleSubmit = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (isSubmitting) {
      toast.warn("Please wait, form is already submitting...");
      return;
    }
    setSubmitErrors({});
    setItemFieldErrors([]);
    const validation = validateForm();
    if (Object.keys(validation.fieldErrors).length > 0 || validation.itemErrors.length > 0) {
      setSubmitErrors(validation.fieldErrors);
      setItemFieldErrors(validation.itemErrors);
      toast.error("Please fix all validation errors before submitting");
      return;
    }
    setIsSubmitting(true);
    try {
      const filteredTerms = terms.filter((term) => term.key?.trim() !== "" && term.value?.trim() !== "");
      const cleanedItems = formData.items.map((item) => ({
        category: item.category?.id || item.category || null,
        sub_category: item.sub_category?.subcat_id || item.sub_category || null,
        item: item.item?.id || item.item || null,
        size: typeof item.size === "object" ? item.size?.id || null : item.size || null,
        unit: typeof item.unit === "object" ? item.unit?.id || null : item.unit || null,
        description: item.description || "",
        quantity: parseFloat(item.quantity) || 0,
        received_qty: parseFloat(item.quantity) || 0,
        rate: parseFloat(item.rate) || 0,
        amount: parseFloat(item.amount) || 0,
        gst_percentage: parseFloat(item.gst_percentage) || 0,
        gst_amount: parseFloat(item.gst_amount) || 0,
        item_total: parseFloat(item.amount) + parseFloat(item.gst_amount),
      }));

      const fd = new FormData();
      fd.append("purchase_voucher_no", formData.voucher_no || "");
      fd.append("purchase_number", formData.voucher_no || "");
      fd.append("invoice_number", formData.invoice_no || "");
      fd.append("invoice_date", formData.invoice_date || "");
      fd.append("lr_no", formData.lr_no || "");
      fd.append("grn_no", formData.grn_no || "");
      fd.append("purchase_order", formData.purchase_order || "");
      fd.append("vehicle_no", formData.vehicle_no || "");
      fd.append("payment_status", formData.payment_status || "Unpaid");
      fd.append("supplier", formData.supplier || "");
      fd.append("project", formData.project || "");
      fd.append("billing_name", formData.billing_name || "");
      fd.append("billing_address", formData.billing_address || "");
      fd.append("billing_pan", formData.billing_pan || "");
      fd.append("billing_gst", formData.billing_gst || "");
      fd.append("billing_email", formData.billing_email || "");
      fd.append("billing_contact", formData.billing_contact || "");
      fd.append("billed_to_name", formData.billed_to_name || "");
      fd.append("billed_to_email", formData.billed_to_email || "");
      fd.append("billed_to_contact", formData.billed_to_contact || "");
      fd.append("billed_to_address", formData.billed_to_address || "");
      fd.append("billed_to_state_name", formData.billed_to_state_name || "");
      fd.append("billed_to_state_code", formData.billed_to_state_code || "");
      fd.append("billed_to_gst_no", formData.billed_to_gst_no || "");
      fd.append("billed_to_pan_no", formData.billed_to_pan_no || "");
      fd.append("include_shipping", includeShipping);
      fd.append("shipping_address", formData.shipping_address || "");
      fd.append("shipping_contact", formData.shipping_contact || "");
      fd.append("shipping_phone", formData.shipping_phone || "");
      fd.append("narration", formData.narration || "");
      fd.append("other_expense", formData.other_expense || "0.00");
      fd.append("good_items", JSON.stringify(cleanedItems));
      fd.append("terms_conditions", JSON.stringify(filteredTerms));
      fd.append("total_amount", formData.total_amount || "0.00");
      fd.append("gst_amount", formData.gst_amount || "0.00");
      fd.append("final_amount", formData.final_amount || "0.00");
      fd.append("created_by", localStorage.getItem("user_id"));
      fd.append("division", formData.division || division?.division_id || "");

      let response;
      if (isEdit && poData?.purchase_voucher_no) {
        response = await UpdatePurchaseVoucher(poData.purchase_voucher_no, fd);
        toast.success("Purchase Voucher updated successfully!");
        setTimeout(() => navigate("/dashboard/purchase-list"), 1500);
      } else {
        response = await CreatePurchaseVoucher(fd);
        toast.success("Purchase Voucher created successfully!");
        setTimeout(() => navigate("/dashboard/purchase-list"), 1500);
      }
    } catch (err) {
      console.error("Submit error:", err);
      let errorMessage = "Failed to submit Purchase Voucher";
      if (err.response?.data) {
        if (typeof err.response.data === "object") {
          errorMessage = Object.values(err.response.data).flat().join(", ");
        } else {
          errorMessage = err.response.data;
        }
      }
      toast.error(errorMessage);
      setIsSubmitting(false);
      return;
    } finally {
      setIsSubmitting(false);
    }
  };

  const removeTerm = (index) => {
    setTerms(terms.filter((_, i) => i !== index));
  };

  useEffect(() => {
    if (!isEdit) return;
    const rows = formData.items || [];
    if (rows.length === 0) return;
    let cancel = false;
    (async () => {
      const subs = [];
      const itemsMap = {};
      for (let i = 0; i < rows.length; i++) {
        const r = rows[i];
        if (r?.category?.id) {
          // const subcatData = await fetchSubCategories(r.category.id);
          // subs[i] = subcatData || [];
          // if (r?.sub_category?.subcat_id) {
            const itemData = await fetchItemsByCategoryAndSubcategory(r.category.id, 0);
            itemsMap[i] = (itemData?.results || []).map((x) => ({ id: x.id, name: x.name }));
          // }
        }
      }
      if (!cancel) {
        setSubcategories(subs);
        setItemOptions(itemsMap);
      }
    })();
    return () => { cancel = true; };
  }, [isEdit, formData.items]);

  const handleInputChange = async (index, key, value) => {
    const updatedRows = [...formData.items];
    let row = { ...updatedRows[index] };

    if (itemFieldErrors[index] && itemFieldErrors[index][key]) {
      const newItemErrors = [...itemFieldErrors];
      delete newItemErrors[index][key];
      if (Object.keys(newItemErrors[index]).length === 0) delete newItemErrors[index];
      setItemFieldErrors(newItemErrors);
    }

    switch (key) {
      case "category":
        row = {
          ...row,
          category: value,
          sub_category: null,
          item: null,
          description: "",
          unit: "",
          unit_name: "",
          rate: "",
          amount: "",
          size: null,
          gst_percentage: "",
          gst_amount: "0.00",
        };
        if (value && value.id) {
          const itemData = await fetchItemsByCategoryAndSubcategory(value.id, 0, page, searchTerm);
          const mappedItems = (itemData.results || []).map((item) => ({
            id: item.id,
            name: item.name,
            item_code: item.item_code || item.code || "",
            unit_id: item.unit || item.uom || null,
            unit_name: item.unit_name || item.uom_name || "",
            size_id: item.size || null,
            size_name: item.size_name || "",
            rate: item.rate || item.unit_price || 0,
            description: item.description || item.item_description || "",
            current_stock: item.current_stock || 0,
          }));
          setItemOptions((prev) => ({ ...prev, [index]: mappedItems }));
        } else {
          setItemOptions((prev) => ({ ...prev, [index]: [] }));
        }
        break;
      case "item":
        const selectedItem = value;
        if (selectedItem) {
          let foundUnit = selectedItem?.unit_id || "";
          let foundUnitName = selectedItem?.unit_name || "";
          if (selectedItem?.unit_id) {
            const unitObj = unitOptions.find((u) => String(u.id) === String(selectedItem.unit_id));
            if (unitObj) {
              foundUnit = unitObj.id;
              foundUnitName = unitObj.name || unitObj.unit_name || "";
            }
          }
          let foundSize = null;
          if (selectedItem?.size_id) {
            foundSize = sizeOptions.find((s) => String(s.id) === String(selectedItem.size_id)) || null;
          }
          row = {
            ...row,
            item: selectedItem,
            description: selectedItem?.description || selectedItem?.name || "",
            rate: selectedItem?.rate || selectedItem?.price || "",
            unit: foundUnit,
            unit_name: foundUnitName,
            size: foundSize,
          };
          const qty = parseFloat(row.quantity) || 0;
          const rate = parseFloat(row.rate) || 0;
          row.amount = (qty * rate).toFixed(2);
          row.gst_amount = calculateItemGST(row.amount, row.gst_percentage);
        } else {
          row = { ...row, item: null, description: "", rate: "", amount: "", gst_amount: "0.00" };
        }
        break;
      case "size":
        row = { ...row, size: value };
        break;
      case "unit":
        if (value && typeof value === "object") {
          row = { ...row, unit: value.id || "", unit_name: value.name || value.unit_name || "" };
        } else {
          row = { ...row, unit: value || "", unit_name: "" };
        }
        break;
      case "quantity":
      case "rate":
        row = { ...row, [key]: value };
        const newQty = parseFloat(key === "quantity" ? value : row.quantity) || 0;
        const newRate = parseFloat(key === "rate" ? value : row.rate) || 0;
        row.amount = (newQty * newRate).toFixed(2);
        row.gst_amount = calculateItemGST(row.amount, row.gst_percentage);
        break;
      case "gst_percentage":
        row = { ...row, gst_percentage: value };
        row.gst_amount = calculateItemGST(row.amount, row.gst_percentage);
        break;
      default:
        row = { ...row, [key]: value };
    }
    updatedRows[index] = row;
    updateTotals(updatedRows, formData.other_expense);
  };

  const handleItemInputChange = useCallback(
    debounce(async (index, row, newValue, type) => {
      if (!newValue || newValue.trim() === "") {
        if (type === "category") {
          const catData = await getCategories();
          setCategories(Array.isArray(catData.results) ? catData.results : catData);
        }
        if (type === "item" && row.category) {
          const itemData = await fetchItemsByCategoryAndSubcategory(row.category.id, 0);
          const mappedItems = (itemData.results || []).map((item) => ({
            id: item.id,
            name: item.name,
            unit_id: item.unit || null,
            unit_name: item.unit_name || "",
            size_id: item.size || null,
            size_name: item.size_name || "",
            rate: item.rate || 0,
            description: item.description || "",
          }));
          setItemOptions((prev) => ({ ...prev, [index]: mappedItems }));
        }
        if (type === "size") {
          const sizeData = await getSizes();
          setSizeOptions(Array.isArray(sizeData.results) ? sizeData.results : sizeData);
        }
        return;
      }

      if (type === "category") {
        const catData = await getCategories(1, newValue || "");
        setCategories(Array.isArray(catData.results) ? catData.results : catData);
      }
      if (type === "item" && row.category) {
        const itemData = await fetchItemsByCategoryAndSubcategory(row.category.id, 0, 1, newValue || "");
        const mappedItems = (itemData.results || []).map((item) => ({
          id: item.id,
          name: item.name,
          unit_id: item.unit || null,
          unit_name: item.unit_name || "",
          size_id: item.size || null,
          size_name: item.size_name || "",
          rate: item.rate || 0,
          description: item.description || "",
        }));
        setItemOptions((prev) => ({ ...prev, [index]: mappedItems }));
      }
      if (type === "size") {
        const sizeData = await getSizes(newValue || "");
        setSizeOptions(Array.isArray(sizeData.results) ? sizeData.results : sizeData);
      }
    }, 500),
    [sizeOptions]
  );

  const handleSaveDraft = () => {
    sessionStorage.setItem("poDraft", JSON.stringify(formData));
    sessionStorage.setItem("poTerms", JSON.stringify(terms));
    toast.info("Purchase Voucher draft saved!");
  };

  useEffect(() => {
    const draftForm = sessionStorage.getItem("poDraft");
    const draftTerms = sessionStorage.getItem("poTerms");
    if (draftForm) {
      try {
        setFormData(JSON.parse(draftForm));
        if (draftTerms) setTerms(JSON.parse(draftTerms));
        toast.info("Loaded Purchase Voucher draft");
      } catch (e) { }
    }
  }, []);

  return (
    <Box sx={{ px: 0, pt: 0, mt: -3, maxWidth: 1200, mx: "auto" }}>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
      {/* Top Buttons */}
      <Box sx={{ display: "flex", justifyContent: "right", alignItems: "center", mb: 3, flexDirection: isMobile ? "column" : "row", gap: isMobile ? 2 : 0 }}>
        <Box sx={{ display: "flex", gap: 2, flexDirection: isMobile ? "column" : "row", width: isMobile ? "100%" : "auto" }}>
          <Button type="button" variant="outlined" onClick={handleSaveDraft} fullWidth={isMobile} sx={{ height: 40, fontSize: "0.875rem", color: "#ff8400ff", borderColor: "#ff8400ff", fontWeight: 500, textTransform: "none", minWidth: 120, borderRadius: 0 }}>
            Save Draft
          </Button>
          <Button type="button" variant="contained" color="primary" onClick={(e) => handleSubmit(e)} disabled={isSubmitting} fullWidth={isMobile} sx={{ height: 40, fontSize: "0.875rem", fontWeight: 600, textTransform: "none", minWidth: 180, borderRadius: 0 }}>
            {isSubmitting ? "Submitting..." : "Submit Purchase List"}
          </Button>
        </Box>
      </Box>

      {/* ========== TOP FORM SECTION ========== */}
      <Box border="1px solid #ccc" borderRadius="8px" sx={{ mb: 3, p: isMobile ? 1.5 : 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={3}>
            <TextField fullWidth label="Voucher No" value={formData.voucher_no || ""} disabled error={!!submitErrors.voucher_no} helperText={submitErrors.voucher_no} InputProps={{ sx: { height: 45, fontSize: "0.875rem", borderRadius: 1, bgcolor: "#f5f5f5" } }} />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField fullWidth label="Invoice No" value={formData.invoice_no || ""} onChange={handleChange("invoice_no")} InputProps={{ sx: { height: 45, fontSize: "0.875rem", borderRadius: 1 } }} />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField fullWidth label="Invoice Date" type="date" value={formData.invoice_date || ""} onChange={handleChange("invoice_date")} InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 45, fontSize: "0.875rem", borderRadius: 1 } }} />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField fullWidth label="LR No" value={formData.lr_no || ""} onChange={handleChange("lr_no")} InputProps={{ sx: { height: 45, fontSize: "0.875rem", borderRadius: 1 } }} />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField fullWidth label="GRN No" value={formData.grn_no || ""} onChange={handleChange("grn_no")} InputProps={{ sx: { height: 45, fontSize: "0.875rem", borderRadius: 1 } }} />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField fullWidth label="Vehicle No" value={formData.vehicle_no || ""} onChange={(e) => handleFieldChange("vehicle_no", e.target.value)} InputProps={{ sx: { height: 45, fontSize: "0.875rem", borderRadius: 1 } }} />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField fullWidth select label="Payment Status" value={formData.payment_status || ""} onChange={handleChange("payment_status")} InputProps={{ sx: { height: 45, fontSize: "0.875rem", borderRadius: 1 } }}>
              <MenuItem value="">Select</MenuItem>
              <MenuItem value="Paid">Paid</MenuItem>
              <MenuItem value="Unpaid">Unpaid</MenuItem>
              <MenuItem value="Partial">Partial</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Autocomplete
              options={suppliers}
              getOptionLabel={(option) => option.name || ""}
              value={(Array.isArray(suppliers) && suppliers.find((s) => s.id === formData.supplier)) || null}
              loading={supplierLoading}
              isOptionEqualToValue={(option, value) => option.id === value?.id}
              onChange={async (e, newValue) => {
                if (newValue) {
                  setFormData((prev) => ({
                    ...prev,
                    supplier: newValue.id,
                    billing_name: newValue.name || "",
                    billing_address: newValue.address || "",
                    billing_pan: newValue.pan || "",
                    billing_gst: newValue.gst || "",
                    billing_email: newValue.email || "",
                    billing_contact: newValue.contact || "",
                  }));
                  if (submitErrors.supplier) setSubmitErrors((prev) => ({ ...prev, supplier: "" }));
                  try {
                    const poData = await fetchpos({ supplier: newValue.id, approval_status: "Approved" });
                    const poList = poData?.results || [];
                    if (poList.length > 0) {
                      const latestPO = poList[0];
                      const mappedItems = (latestPO.items || []).map((item) => ({
                        category: item.category ? { id: item.category, name: item.category_name || "" } : null,
                        sub_category: item.sub_category ? { subcat_id: item.sub_category, name: item.sub_category_name || "" } : null,
                        item: item.item ? { id: item.item, name: item.item_name || "" } : null,
                        unit: item.unit || "",
                        unit_name: item.unit_name || "",
                        description: item.description || item.item_name || "",
                        quantity: parseFloat(item.quantity) || 0,
                        used_qty: 0,
                        rate: parseFloat(item.rate) || 0,
                        amount: (parseFloat(item.rate) || 0) * (parseFloat(item.quantity) || 0),
                        size: item.size ? (typeof item.size === "object" ? item.size : { id: item.size, name: item.size_name || "" }) : null,
                        size_name: item.size_name || "",
                        gst_percentage: item.gst_percentage || "",
                        gst_amount: "0.00",
                      }));
                      setFormData((prev) => ({
                        ...prev,
                        billing_name: latestPO.billing_name || newValue.name || "",
                        billing_address: latestPO.billing_address || newValue.address || "",
                        billing_pan: latestPO.billing_pan || newValue.pan || "",
                        billing_gst: latestPO.billing_gst || newValue.gst || "",
                        billing_email: latestPO.billing_email || newValue.email || "",
                        billing_contact: latestPO.billing_contact || newValue.contact || "",
                        project: latestPO.project || "",
                        items: mappedItems.length > 0 ? mappedItems : prev.items,
                      }));
                      const totals = recalcMainTotals(mappedItems, formData.other_expense);
                      setFormData(prev => ({ ...prev, ...totals }));
                      if (latestPO.terms_conditions?.length > 0) setTerms(latestPO.terms_conditions);
                      toast.success(`Previous PO data loaded!`);
                    }
                  } catch (error) {
                    console.error("Error fetching PO:", error);
                  }
                } else {
                  setFormData((prev) => ({ ...prev, supplier: "", billing_name: "", billing_address: "", billing_pan: "", billing_gst: "", billing_email: "", billing_contact: "" }));
                }
              }}
              onInputChange={(e, newInputValue) => setSupplierSearch(newInputValue)}
              renderInput={(params) => (
                <TextField {...params} label="Select Supplier" fullWidth error={!!submitErrors.supplier} helperText={submitErrors.supplier} InputProps={{ ...params.InputProps, sx: { height: 45, fontSize: "0.875rem", borderRadius: 1 } }} />
              )}
            />
          </Grid>
      <Grid item xs={12}>
  <TextField
    fullWidth
    label="Narration"
    value={formData.narration || ""}
    onChange={handleChange("narration")}
    multiline
    rows={1}
    InputProps={{
      sx: {
        fontSize: "0.875rem",
        borderRadius: 1,
      },
    }}
  />
</Grid>
        </Grid>
      </Box>

      {/* ========== BILLED FROM SECTION (omitted for brevity, keep as is) ========== */}

      {/* ========== SHIPPING SECTION ========== */}
      {/* <Box sx={{ mb: 3 }}>
        <FormControlLabel control={<Checkbox checked={includeShipping} onChange={(e) => setIncludeShipping(e.target.checked)} />} label="Include Shipping Details" />
        {includeShipping && (
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={3}>
              <TextField fullWidth label="Shipping Address" value={formData.shipping_address || ""} onChange={handleChange("shipping_address")} InputProps={{ sx: { height: 45, fontSize: "0.875rem", borderRadius: 1 } }} />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField fullWidth label="Contact Person" value={formData.shipping_contact || ""} onChange={(e) => setFormData((prev) => ({ ...prev, shipping_contact: e.target.value }))} InputProps={{ sx: { height: 45, fontSize: "0.875rem", borderRadius: 1 } }} />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField fullWidth label="Phone" value={formData.shipping_phone || ""} onChange={(e) => setFormData((prev) => ({ ...prev, shipping_phone: e.target.value.replace(/[^0-9+\s-]/g, "") }))} inputProps={{ maxLength: 15 }} InputProps={{ sx: { height: 45, fontSize: "0.875rem", borderRadius: 1 } }} />
            </Grid>
          </Grid>
        )}
      </Box> */}

      {submitErrors.items && (
        <Box sx={{ mb: 2, p: 2, bgcolor: "#fff3cd", border: "1px solid #ffeaa7", borderRadius: 1 }}>
          <Typography color="error" variant="body2">{submitErrors.items}</Typography>
        </Box>
      )}

      {/* ========== ITEMS TABLE ========== */}
      <TableContainer sx={{ mt: 2, overflowX: "auto", WebkitOverflowScrolling: "touch", "&::-webkit-scrollbar": { height: 8 }, "&::-webkit-scrollbar-thumb": { backgroundColor: "#ccc", borderRadius: 4 } }}>
        <Box border="1px solid #ccc" borderRadius="8px" sx={{ mb: 3, p: 2, minWidth: 2200 }}>
          <Table sx={{ minWidth: 2050 }}>
            <TableHead>
              <TableRow sx={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>
                <TableCell>S.No</TableCell>
                <TableCell>Category</TableCell>
                <TableCell>Item</TableCell>
                <TableCell>UOM</TableCell>
                <TableCell>Product Type</TableCell>
                <TableCell>Quantity</TableCell>
                <TableCell>Unit Price</TableCell>
                <TableCell>Amount</TableCell>
                <TableCell>GST %</TableCell>
                <TableCell>GST Amt</TableCell>
                <TableCell>Total</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {formData.items.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>
                    <Autocomplete
                      options={Array.isArray(categories) ? categories : []}
                      getOptionLabel={(opt) => opt.name}
                      isOptionEqualToValue={(opt, val) => opt?.id === val?.id}
                      value={item.category || null}
                      onChange={async (e, val, reason) => {
                        if (reason === "clear" || !val) {
                          await handleItemInputChange(index, item, "", "category");
                          handleInputChange(index, "category", null);
                          return;
                        }
                        handleInputChange(index, "category", val);
                      }}
                      onInputChange={(e, newValue, reason) => { if (reason === "input") handleItemInputChange(index, item, newValue, "category"); }}
                      renderInput={(params) => <TextField {...params} label="Category" size="small" sx={{ width: "180px" }} error={!!itemFieldErrors[index]?.category} helperText={itemFieldErrors[index]?.category} />}
                    />
                  </TableCell>
                  <TableCell>
                    <Autocomplete
                      options={Array.isArray(itemOptions[index]) ? itemOptions[index] : []}
                      getOptionLabel={(opt) => opt.name}
                      isOptionEqualToValue={(opt, val) => opt?.id === val?.id}
                      value={item.item}
                      onChange={async (e, val, reason) => {
                        if (reason === "clear" || !val) {
                          await handleItemInputChange(index, item, "", "item");
                          handleInputChange(index, "item", null);
                          return;
                        }
                        handleInputChange(index, "item", val);
                      }}
                      onInputChange={(e, newValue) => handleItemInputChange(index, item, newValue, "item")}
                      renderInput={(params) => <TextField {...params} size="small" sx={{ width: "180px" }} label="Item" error={!!itemFieldErrors[index]?.item} helperText={itemFieldErrors[index]?.item} />}
                    />
                  </TableCell>
                  <TableCell>
                    <Autocomplete
                      size="small"
                      options={unitOptions || []}
                      getOptionLabel={(option) => { if (!option) return ""; if (typeof option === "object") return option?.name || option?.unit_name || ""; const found = unitOptions.find(u => String(u.id) === String(option)); return found?.name || ""; }}
                      value={item.unit ? unitOptions.find(u => String(u.id) === String(item.unit)) || null : null}
                      onChange={(e, newValue) => handleInputChange(index, "unit", newValue)}
                      isOptionEqualToValue={(option, value) => { if (!option && !value) return true; if (!option || !value) return false; return String(option.id) === String(value.id); }}
                      renderInput={(params) => <TextField {...params} label="Unit" size="small" sx={{ width: "150px" }} error={!!itemFieldErrors[index]?.unit} helperText={itemFieldErrors[index]?.unit} />}
                    />
                  </TableCell>
                  <TableCell>
                    <Autocomplete
                      size="small"
                      options={Array.isArray(sizeOptions) ? sizeOptions : []}
                      getOptionLabel={(option) => { if (!option) return ""; return option?.type || option?.size || option?.name || ""; }}
                      value={item.size ? (typeof item.size === "object" ? item.size : sizeOptions.find(s => String(s.id) === String(item.size)) || null) : null}
                      onChange={(e, newValue) => handleInputChange(index, "size", newValue)}
                      onInputChange={(e, newInputValue, reason) => { if (reason === "input") handleItemInputChange(index, item, newInputValue, "size"); }}
                      isOptionEqualToValue={(option, value) => { if (!option && !value) return true; if (!option || !value) return false; return String(option.id) === String(value.id); }}
                      renderInput={(params) => <TextField {...params} label="Product Type" size="small" sx={{ width: "150px" }} />}
                    />
                  </TableCell>
                  <TableCell>
                    <input type="number" value={item.quantity} onChange={(e) => handleItemChange(index, "quantity", e.target.value)} onFocus={(e) => { if (e.target.value === "0") e.target.value = ""; }} onBlur={(e) => handleItemChange(index, "quantity", (parseFloat(e.target.value) || 0).toString())} style={{ width: "150px", height: "36px", padding: "8px", fontSize: "0.875rem", borderRadius: "4px", backgroundColor: "#fcfcfc", border: itemFieldErrors[index]?.quantity ? "1px solid red" : "1px solid #c4c4c4" }} />
                    {itemFieldErrors[index]?.quantity && <div style={{ color: "red", fontSize: "0.8rem" }}>{itemFieldErrors[index]?.quantity}</div>}
                  </TableCell>
                  <TableCell>
                    <input type="number" value={item.rate} onChange={(e) => handleItemChange(index, "rate", e.target.value)} onBlur={(e) => handleItemChange(index, "rate", (parseFloat(e.target.value) || 0).toString())} style={{ width: "150px", padding: "8px", height: "36px", fontSize: "0.875rem", borderRadius: "4px", backgroundColor: "#fcfcfc", border: itemFieldErrors[index]?.rate ? "1px solid red" : "1px solid #c4c4c4" }} />
                    {itemFieldErrors[index]?.rate && <div style={{ color: "red", fontSize: "0.8rem" }}>{itemFieldErrors[index]?.rate}</div>}
                  </TableCell>
                  <TableCell>
                    <input type="number" value={item.amount} readOnly style={{ width: "150px", padding: "8px", height: "36px", fontSize: "0.875rem", borderRadius: "4px", backgroundColor: "#fcfcfc", border: "1px solid #c4c4c4" }} />
                  </TableCell>
                  <TableCell>
                    <input type="number" value={item.gst_percentage} onChange={(e) => handleItemChange(index, "gst_percentage", e.target.value)} onBlur={(e) => handleItemChange(index, "gst_percentage", (parseFloat(e.target.value) || 0).toString())} style={{ width: "100px", padding: "8px", height: "36px", fontSize: "0.875rem", borderRadius: "4px", backgroundColor: "#fcfcfc", border: "1px solid #c4c4c4" }} />
                  </TableCell>
                  <TableCell>
                    <input type="number" value={item.gst_amount} readOnly style={{ width: "120px", padding: "8px", height: "36px", fontSize: "0.875rem", borderRadius: "4px", backgroundColor: "#fcfcfc", border: "1px solid #c4c4c4" }} />
                  </TableCell>
                  <TableCell>
                    <input type="text" readOnly value={(parseFloat(item.amount) + parseFloat(item.gst_amount)).toFixed(2)} style={{ width: "150px", height: "36px", padding: "8px", fontSize: "0.875rem", borderRadius: "4px", backgroundColor: "#fcfcfc", border: "1px solid #c4c4c4" }} />
                  </TableCell>
                  <TableCell>
                    <input type="text" value={item.description} onChange={(e) => handleItemChange(index, "description", e.target.value)} style={{ width: "150px", height: "36px", padding: "8px", fontSize: "0.875rem", borderRadius: "4px", backgroundColor: "#fcfcfc", border: "1px solid #c4c4c4" }} />
                  </TableCell>
                  <TableCell>
                    <IconButton onClick={() => deleteItemRow(index)} color="error"><DeleteIcon /></IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </TableContainer>

      {/* Add Item + Grand Total */}
      <TableContainer>
        <Box sx={{ mb: 3, width: "100%" }}>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell colSpan={13} align="center">
                  <Button variant="outlined" onClick={addItemRow} startIcon={<AddIcon />}>Add Item</Button>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={13}>
                  <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 2, flexWrap: "wrap" }}>
                    <strong>Total Amount:</strong>
                    <TextField value={formData.total_amount} size="small" sx={{ width: "120px" }} disabled />
                    <strong>Total GST:</strong>
                    <TextField value={formData.gst_amount} size="small" sx={{ width: "120px" }} disabled />
                    <strong>Other Expense:</strong>
                    <TextField type="number" value={formData.other_expense} onChange={(e) => handleOtherExpenseChange(e.target.value)} size="small" sx={{ width: "120px" }} />
                    <strong>Grand Total:</strong>
                    <TextField value={formData.final_amount} size="small" sx={{ width: "120px", fontWeight: "bold" }} disabled />
                  </Box>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Box>
      </TableContainer>

      {/* ========== TERMS & CONDITIONS ========== */}
      {/* <Box border="1px solid #ccc" borderRadius="8px" sx={{ mb: 3, p: 2 }}>
        <Typography variant="h6" gutterBottom>Terms & Conditions</Typography>
        {terms.map((term, index) => (
          <Grid container spacing={1} key={index} alignItems="center" sx={{ mb: 1 }}>
            <Grid item xs={5}><TextField fullWidth placeholder="Term" value={term.key} onChange={(e) => handleTermChange(index, "key", e.target.value)} size="small" /></Grid>
            <Grid item xs={6}><TextField fullWidth placeholder="Value" value={term.value} onChange={(e) => handleTermChange(index, "value", e.target.value)} size="small" /></Grid>
            <Grid item xs={1}><IconButton onClick={() => removeTerm(index)} color="error"><DeleteIcon /></IconButton></Grid>
          </Grid>
        ))}
        <Button variant="outlined" sx={{ mt: 1 }} onClick={() => setTerms([...terms, { key: "", value: "", is_default: false }])}>+ Add Term</Button>
      </Box> */}
    </Box>
  );
}